import React, { useState } from "react";
import {
    IconChipDepartment,
    IconCustomAccess
} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";
import { WORK_SHIFT_RESOURCE } from "../Model/Models";
import { AssignedShiftResourceApp } from "../Functionality/AssignedShiftResourceApp";
import { TabPanelApp } from "../../../../../components/ResourceAssignment/Functionality/TabPanelApp";
import AssignedTabResource from "../../../../../components/ResourceAssignment/SubComponents/AssignedTabResource";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Read-only assigned list for one work shift resource (custom access /
 * departments) inside the list detail expand. Owns its own tab state and renders
 * the server assigned page through AssignedShiftResource in readOnly mode (no
 * checkbox, no deletion). Mirrors the foodie FoodieShiftRenderDetails.
 */
const RenderAssignedSection = ({ resource, id, title, Icon }) => {
    const [selected, setSelected] = useState([]);
    const [selectForDelete, setSelectForDelete] = useState([]);

    const {
        t,
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        triggerDelete, setTriggerDelete,
        isAllChecked, setIsAllChecked,
    } = TabPanelApp();

    return (
        <AssignedTabResource
            useAssignedApp={AssignedShiftResourceApp}
            readOnly={true}
            resource={resource}
            id={id}
            selected={selected}
            setSelected={setSelected}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            triggerDelete={triggerDelete}
            setTriggerDelete={setTriggerDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            results={results}
            setResults={setResults}
            setBodyForExport={setBodyForExport}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            renderModuleTitle={
                <div className='d-flex align-items-center justify-content-start mb-3'>
                    <div><Icon className="mr-8px mb-1" /></div>
                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                        <CustomTooltip
                            text={t(title)}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                            showIfTruncated={true}
                        />
                    </div>
                    <div className='vertical-separator-shades-950 h-auto' />
                </div>
            }
        />
    );
};

/**
 * Expanded row detail for a work shift list entry. Renders the shift's assigned
 * custom access (employees) and departments as read-only paginated lists,
 * reusing AssignedShiftResource (the same component used in the create/update
 * flow).
 *
 * @param {Object} props
 * @param {Object} props.row - Shift list row ({ id }).
 * @returns {JSX.Element}
 */
export const WorkShiftRenderDetails = ({ row }) => {
    return (
        <div className='shift-detail-lists'>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={WORK_SHIFT_RESOURCE.USERS} id={row.id} title={'assigned_employees'} Icon={IconCustomAccess} />
            </div>
            <div className='mb-5 mt-4'>
                <RenderAssignedSection resource={WORK_SHIFT_RESOURCE.DEPARTMENTS} id={row.id} title={'assigned_departments'} Icon={IconChipDepartment} />
            </div>
        </div>
    );
}
